define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/bind',
    '../Util/callbackSystem',
    '../Util/encode',
    '../Layer/ElevationLayer',
    '../Layer/FeatureLayer',
    '../Layer/ImageLayer',
    '../Layer/MeshLayer',
    '../Layer/ModelLayer',
    '../Environment/Atmosphere',
    '../Environment/GlobalFog',
    '../Environment/GlobalShadow',
    '../2D/Plotting',
    '../3D/DistanceMeasure',
    '../3D/Label',
    '../3D/GeoFence',
    '../3D/Model',
    '../3D/Polygon',
    '../3D/Ripple',
    '../2D/MultipleCircles',
    '../AI/Path',
    '../Analysis/ViewShedAnalysis',
    '../Analysis/SightLineAnalysis',
    '../System/Vec3Obj',
    '../System/Monitor'
], function (
    defaultValue,
    defined,
    bind,
    callbackSystem,
    encode,
    ElevationLayer,
    FeatureLayer,
    ImageLayer,
    MeshLayer,
    ModelLayer,
    Atmosphere,
    GlobalFog,
    GlobalShadow,
    Plotting,
    DistanceMeasure,
    Label,
    GeoFence,
    Model,
    Polygon,
    Ripple,
    MultipleCircles,
    Path,
    ViewShedAnalysis,
    SightLineAnalysis,
    Vec3Obj,
    Monitor
) {
    'use strict'
    var startTime = performance.now()
    Element.prototype.MapInstance = null
    Element.prototype.Wasm = null
    var Map = (() => {
        return function (container, props) {
            startTime = performance.now()
            if (Element.prototype.MapInstance) {
                if (Element.prototype.DestroyState) {
                    let systemThreadNum = 4
                    if (navigator) {
                        systemThreadNum = navigator.hardwareConcurrency - 5
                        if (systemThreadNum < 4) {
                            systemThreadNum = 4
                        } else if (systemThreadNum > 8) {
                            systemThreadNum = 8
                        }
                    }
                    let threadNum = defaultValue(props.dataThreadNum, systemThreadNum)
                    let nodeNum = defaultValue(props.nodeNum, 3000)
                    let bProgress = defaultValue(props.bProgress, true)
                    let licIp = defaultValue(props.licIp, "")
                    let licPort = defaultValue(props.licPort, -1)
                    let protocol = 0
                    if (window.location.protocol === "https:") {
                        protocol = 1
                    }
                    let company = defaultValue(props.company, "浙江科澜信息技术有限公司")
                    let bShowCopyright = defaultValue(props.bShowCopyright, true)
                    let copyrightYear = defaultValue(props.copyrightYear, 2004)
                    if (bProgress) {
                        this.canvas = document.getElementById(container)
                        const rect = this.canvas.getBoundingClientRect()
                        Element.prototype.MapInstance.initProgress(rect)
                    }
                    Element.prototype.MapInstance.initApp(container, threadNum, nodeNum, licIp, licPort, protocol, company, bShowCopyright, copyrightYear)
                }
                return Element.prototype.MapInstance
            }
            return Element.prototype.MapInstance = new MapSingleton(container, props)
        }
    })()
    //{build:true}表示直接构造js对象，不做实际的接口调用
    const group = (avatar, component, avatarUuid, componentUuid) => {
        if (avatar == ModelLayer.avatarType && component == ModelLayer.componentType) {
            let newObject = new ModelLayer({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.modelLayers.push(newObject)
        } else if (avatar == MeshLayer.avatarType && component == MeshLayer.componentType) {
            let newObject = new MeshLayer({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.meshLayers.push(newObject)
        } else if (avatar == ImageLayer.avatarType && component == ImageLayer.componentType) {
            let newObject = new ImageLayer({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.imageLayers.push(newObject)
        } else if (avatar == ElevationLayer.avatarType && component == ElevationLayer.componentType) {
            let newObject = new ElevationLayer({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.elevationLayers.push(newObject)
        } else if (avatar == FeatureLayer.avatarType && component == FeatureLayer.componentType) {
            let newObject = new FeatureLayer({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.featureLayers.push(newObject)
        } else if (avatar == Atmosphere.avatarType && component == Atmosphere.componentType) {
            let newObject = new Atmosphere({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            newObject.getProperties()
            Element.prototype.Map.atmospheres.push(newObject)
        } else if (avatar == GlobalFog.avatarType && component == GlobalFog.componentType) {
            let newObject = new GlobalFog({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            newObject.getProperties()
            Element.prototype.Map.globalFogs.push(newObject)
        } else if (avatar == GlobalShadow.avatarType && component == GlobalShadow.componentType) {
            let newObject = new GlobalShadow({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            newObject.getProperties()
            Element.prototype.Map.globalShadows.push(newObject)
        } else if (avatar == Plotting.avatarType && component == Plotting.componentType) {
            let newObject = new Plotting({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.plottings.push(newObject)
        } else if (avatar == ViewShedAnalysis.avatarType && component == ViewShedAnalysis.componentType) {
            let newObject = new ViewShedAnalysis({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.viewShedAnalysiss.push(newObject)
        } else if (avatar == SightLineAnalysis.avatarType && component == SightLineAnalysis.componentType) {
            let newObject = new SightLineAnalysis({ build: true })
            newObject.avatarUuid = avatarUuid
            newObject.componentUuid = componentUuid
            Element.prototype.Map.sightLineAnalysiss.push(newObject)
        } else if (avatar == Label.avatarType) {
            // 检查是否已存在相同avatarUuid的Label
            let exists = Element.prototype.Map.labels.some(label => label.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new Label({ build: true })
                newObject.avatarUuid = avatarUuid
                Element.prototype.Map.labels.push(newObject)
            }
        } else if (avatar == GeoFence.avatarType && component == GeoFence.componentType) {
            let exists = Element.prototype.Map.geoFences.some(geoFence => geoFence.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new GeoFence({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.geoFences.push(newObject)
            }
        } else if (avatar == Model.avatarType && component == Model.componentType) {
            let exists = Element.prototype.Map.models.some(model => model.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new Model({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.models.push(newObject)
            }
        } else if (avatar == Polygon.avatarType && component == Polygon.componentType) {
            let exists = Element.prototype.Map.polygons.some(polygon => polygon.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new Polygon({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.polygons.push(newObject)
            }
        } else if (avatar == Ripple.avatarType && component == Ripple.componentType) {
            let exists = Element.prototype.Map.ripples.some(ripple => ripple.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new Ripple({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.ripples.push(newObject)
            }
        } else if (avatar == MultipleCircles.avatarType && component == MultipleCircles.componentType) {
            let exists = Element.prototype.Map.multipleCircles.some(multipleCircles => multipleCircles.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new MultipleCircles({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.multipleCircles.push(newObject)
            }
        } else if (avatar == Path.avatarType && component == Path.componentType) {
            let exists = Element.prototype.Map.paths.some(path => path.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new Path({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.paths.push(newObject)
            }
        } else if (avatar == DistanceMeasure.avatarType && component == DistanceMeasure.componentType) {
            let exists = Element.prototype.Map.measures.some(measures => measures.avatarUuid === avatarUuid)
            if (!exists) {
                let newObject = new DistanceMeasure({ build: true })
                newObject.avatarUuid = avatarUuid
                newObject.componentUuid = componentUuid
                Element.prototype.Map.measures.push(newObject)
            }
        }
    }
    const groupClear = () => {
        Element.prototype.Map.modelLayers = []
        Element.prototype.Map.meshLayers = []
        Element.prototype.Map.imageLayers = []
        Element.prototype.Map.elevationLayers = []
        Element.prototype.Map.featureLayers = []
        Element.prototype.Map.atmospheres = []
        Element.prototype.Map.globalFogs = []
        Element.prototype.Map.globalShadows = []
        Element.prototype.Map.geoCuboids = []
        Element.prototype.Map.geoSpheres = []
        Element.prototype.Map.plottings = []
        Element.prototype.Map.viewShedAnalysiss = []
        Element.prototype.Map.sightLineAnalysiss = []
        Element.prototype.Map.presentations = []
        Element.prototype.Map.labels = []
        Element.prototype.Map.cameras = []
        Element.prototype.Map.videoFusions = []
        Element.prototype.Map.geoFences = []
        Element.prototype.Map.polygons = []
        Element.prototype.Map.ripples = []
        Element.prototype.Map.models = []
        Element.prototype.Map.paths = []
        Element.prototype.Map.multipleCircles = []
        Element.prototype.Map.measures = []
    }
    /**
     * 返回值类型为空的回调函数。
     * @callback CallbackNull 
     */

    /**
     * 返回值类型为Boolean的回调函数。
     * @callback CallbackBoolean 
     * @param {Boolean} state 成功状态。
     */

    /**
     * 返回值类型为String的回调函数。
     * @callback CallbackString 
     * @param {String} str 信息。
     */

    /**
     * 返回值类型为对象的回调函数。
     * @callback CallbackObj 
     * @param {Object} obj 对象。
     */

    /**
     * 返回值类型为对象数组的回调函数。
     * @callback CallbackObjArr 
     * @param {Array.<Object>} objArr 对象数组。
     */

    /**
     * 三维地图管理器。
     * <br /><br />
     * <div align='center'>
     * <img src='images/Map.png' width='900' height='650' /><br />
     * 三维地图初始化效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/Map.html|CooWasm Map demo}
     * @alias Map
     * @constructor
     *
     * @param {String} [container] 绑定的canvas标签id。
     * @param {Object} [props] 包含如下属性的Object：
     * @param {Number} [props.dataThreadNum = 2] 数据线程数量，自动根据电脑CPU线程数配置，理论核心-5为其推荐值。
     * @param {Number} [props.nodeNum = 3000] 数据节点加载上限数，数值越大，节点可驻留显存数量越多。
     * @param {CallbackNull} [props.initCallback=null] 初始回调函数,可在初始化时调用外部传入的函数。
     * @example
     * var xxx = new CooWasm.Map({
     *     container:"canvas"
     * })
     */
    class MapSingleton {
        /**
         * 
         * @type {Array.<ModelLayer>}
         * @description 人工模型图层数组。
         * 
         */
        modelLayers = []
        /**
         * 
         * @type {Array.<MeshLayer>}
         * @description 倾斜摄影图层数组。
         * 
         */
        meshLayers = []
        /**
         * 
         * @type {Array.<ImageLayer>}
         * @description 地形影像图层数组。
         * 
         */
        imageLayers = []
        /**
         * 
         * @type {Array.<ElevationLayer>}
         * @description 地形高程图层数组。
         * 
         */
        elevationLayers = []
        /**
         * 
         * @type {Array.<FeatureLayer>}
         * @description 矢量图层数组。
         * 
         */
        featureLayers = []
        /**
         * 
         * @type {Array.<Atomosphere>}
         * @description 大气层数组。
         * @private
         */
        atmospheres = []
        /**
         * 
         * @type {Array.<GlobalFog>}
         * @description 全球雾数组。
         * @private
         */
        globalFogs = []
        /**
         * 
         * @type {Array.<GlobalShadow>}
         * @description 全球阴影数组。
         * @private
         */
        globalShadows = []
        /**
         * 
         * @type {Array.<GeoCuboid>}
         * @description 长方体数组。
         * @private
         */
        geoCuboids = []
        /**
         * 
         * @type {Array.<GeoSphere>}
         * @description 球体数组。
         * @private
         */
        geoSpheres = []
        /**
         * 
         * @type {Array.<Plotting>}
         * @description 态势标绘数组。
         * @private
         */
        plottings = []
        /**
         * 
         * @type {Array.<ViewShedAnalysiss>}
         * @description 视域分析数组。
         * @private
         */
        viewShedAnalysiss = []
        /**
         * 
         * @type {Array.<SightLineAnalysiss>}
         * @description 通视分析数组。
         * @private
         */
        sightLineAnalysiss = []
        /**
         * 
         * @type {Array.<Label>}
         * @description 标注数组。
         * @private
         */
        labels = []
        /**
         * 
         * @type {Array.<Presentation>}
         * @description 演示系统数组。
         * @private
         */
        presentations = []
        /**
         * 
         * @type {Array.<Camera>}
         * @description 视点数组。
         * @private
         */
        cameras = []
        /**
         * 
         * @type {Array.<VideoFusion>}
         * @description 视频融合数组。
         * @private
         */
        videoFusions = []
        /**
         * 
         * @type {Array.<GeoFence>}
         * @description 地理围栏数组。
         * @private
         */
        geoFences = []
        /**
         * 
         * @type {Array.<Polygon>}
         * @description 面数组。
         * @private
         */
        polygons = []
        /**
         * 
         * @type {Array.<Ripple>}
         * @description 波纹数组。
         * @private
         */
        ripples = []
        /**
         * 
         * @type {Array.<Model>}
         * @description 人工模型数组。
         * @private
         */
        models = []
        /**
         * 
         * @type {Array.<Path>}
         * @description 路径数组。
         * @private
         */
        paths = []
        /**
         * 
         * @type {Array.<MultiCircles>}
         * @description 多重动态圈数组。
         * @private
         */
        multipleCircles = []
        /**
         * 
         * @type {Array.<DistanceMeasure>}
         * @description 测量对象数组。
         * @private
         */
        measures = []
        /**
         * 
         * @type {HTMLElement}
         * @description 绑定的画布。
         * @private
         */
        canvas = null
        /**
         * 
         * @type {NullCallback}
         * @description 初始回调函数。
         * @default null
         * @private
         * 
         */
        initCallback = null
        /**
         * 
         * @type {CallbackObj}
         * @description 鼠标经纬度位置回调函数。
         * @default null
         * @private
         * 
         */
        mousePostionCallback = null
        /**
         *
         * @type {CallbackString}
         * @description 鼠标位置对应比例尺信息回调函数。
         * @default null
         * @private
         * 
         * */
        mouseScaleCallback = null
        /**
         * 
         * @type {Number}
         * @description 数据线程数。
         * @default 4
         * 
         */
        dataThreadNum = 4
        /**
         * 
         * @type {Number}
         * @description 节点数量上限。
         * @default 3000
         * 
         */
        nodeNum = 3000
        /**
         * 
         * @type {String}
         * @description 授权服务ip地址。
         * @default ""
         * 
         */
        licIp = ""
        /**
         * 
         * @type {Number}
         * @description 授权服务端口号。
         * @default -1
         * 
         */
        licPort = -1
        /**
         * 
         * @type {Number}
         * @description 网络协议，默认0，代表Http。
         * @default 0
         * 
         */
        protocol = 0
        /**
         * 
         * @private
         * @type {String}
         * @description 授权水印文字公司名。
         * @default "浙江科澜信息技术有限公司"
         * 
         */
        company = "浙江科澜信息技术有限公司"
        /**
         * 
         * @private
         * @type {Boolean}
         * @description 是否显示版权日期。
         * @default true
         * 
         */
        bShowCopyright = true
        /**
         * 
         * @private
         * @type {Number}
         * @description 版权起始年。
         * @default 2004
         * 
         */
        copyrightYear = 2004
        /**
         * 
         * @type {String}
         * @description cooWasmApi库相对调用网页位置。
         * 
         */
        basePath = ""
        /**
         * 
         * @type {Object}
         * @description canvas的父亲节点。
         * 
         */
        parentNode = null
        /**
         * 
         * @type {Object}
         * @description 进度div。
         * 
         */
        progressDiv = null
        /**
         * 
         * @type {Object}
         * @description 进度div样式。
         * 
         */
        progressStyle = null
        /**
         * 
         * @type {Boolean}
         * @description 是否缓存数据。
         * @default true
         * 
         */
        bCache = true
        /**
         * 
         * @type {Boolean}
         * @description 是否展示进度。
         * @default true
         * 
         */
        bProgress = true
        /**
         * 
         * @type {Boolean}
         * @description 是否正在加载。
         * @default false
         * @private
         * 
         */
        bLoading = false
        /**
         * 
         * @type {Boolean}
         * @description 是否已经初始化。
         * @default false
         * @private
         * 
         */
        bInit = false
        /**
         * 
         * @type {Boolean}
         * @description 是否在自动旋转。
         * @default false
         * @private
         * 
         */
        bRoate = false
        lastRightClick = 0
        DOUBLE_CLICK_TIME = 300

        wasmInstance = null
        
        /**
         * 
         * @type {Monitor}
         * @description 系统监控器实例。
         * @default null
         * @private
         * 
         */
        monitor = null
        /**
         * 
         * @type {Function}
         * @description 键盘事件监听器。
         * @default null
         * @private
         * 
         */
        keyboardHandler = null

        timeStamp = BUILD_TIMESTAMP
        version = BUILD_VERSION
        IndexedDBCache = {
            DB_NAME: 'WasmCache',
            STORE_NAME: 'CooWasmCache',
            VERSION: 7,
            async open() {
                return new Promise((resolve, reject) => {
                    const request = indexedDB.open(this.DB_NAME, this.VERSION)
                    request.onerror = () => reject(request.error)
                    request.onsuccess = () => resolve(request.result)
                    request.onupgradeneeded = (event) => {
                        const db = event.target.result
                        const oldVersion = event.oldVersion
                        const newVersion = event.newVersion
                        if (!db.objectStoreNames.contains(this.STORE_NAME)) {
                            db.createObjectStore(this.STORE_NAME)
                            //console.log("db.createObjectStore")
                        }
                        this.handleUpgrade(db, oldVersion, newVersion)
                    }
                })
            },
            async get(key, currentVersion) {
                const db = await this.open()
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction(this.STORE_NAME, 'readonly')
                    const store = transaction.objectStore(this.STORE_NAME)
                    const request = store.get(key)
                    request.onerror = () => reject(request.error)
                    request.onsuccess = () => {
                        const result = request.result
                        if (result && result.version === currentVersion && result.BUILD_TIMESTAMP === BUILD_TIMESTAMP) {
                            resolve(result.value)
                        } else {
                            resolve(null) // 缓存不存在或版本不匹配
                            console.log(key + " cache is not exist or version is updated!")
                        }
                    }
                })
            },
            async set(key, value, version) {
                const db = await this.open()
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction(this.STORE_NAME, 'readwrite')
                    const store = transaction.objectStore(this.STORE_NAME)
                    const request = store.put({ value, version, BUILD_TIMESTAMP }, key)
                    request.onerror = () => reject(request.error)
                    request.onsuccess = () => resolve()
                })
            },
            handleUpgrade(db, oldVersion, newVersion) {
                console.log("version:" + oldVersion + " => version:" + newVersion)
            },
            async clear() {
                const db = await this.open()
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction(this.STORE_NAME, 'readwrite')
                    const store = transaction.objectStore(this.STORE_NAME)
                    const request = store.clear()
                    request.onerror = () => reject(request.error)
                    request.onsuccess = () => resolve()
                })
            }
        }
        /**
         * Service Worker 缓存助手
         * 仅在 HTTPS 下使用
         */
        ServiceWorkerCache = {
            swRegistration: null,
            isSupported: () => {
                return 'serviceWorker' in navigator && window.location.protocol === 'https:'
            },
            async register(basePath) {
                if (!this.isSupported()) {
                    console.log('[SW] Service Worker not supported or not HTTPS')
                    return null
                }
                
                try {
                    // Service Worker 文件路径
                    // 优先使用 basePath，如果 basePath 为空则使用当前脚本所在目录
                    let swPath
                    
                    if (basePath) {
                        // 用户指定了 basePath
                        swPath = basePath + 'coowasm-sw.js'
                    } else {
                        // 尝试从当前脚本路径推断
                        const scripts = document.getElementsByTagName('script')
                        for (let script of scripts) {
                            if (script.src.includes('cooWasmApi.js') || script.src.includes('Map.js')) {
                                const scriptUrl = new URL(script.src)
                                const scriptPath = scriptUrl.pathname.substring(0, scriptUrl.pathname.lastIndexOf('/') + 1)
                                swPath = scriptUrl.origin + scriptPath + 'coowasm-sw.js'
                                break
                            }
                        }
                        
                        if (!swPath) {
                            swPath = '/coowasm-sw.js'
                        }
                    }
                    
                    console.log('[SW] Registering Service Worker:', swPath)
                    
                    // 确定 scope - 必须与 SW 文件在同一目录或子目录
                    // 从 swPath 中提取目录路径作为 scope
                    let scope
                    if (basePath) {
                        scope = basePath
                    } else {
                        // 从 swPath 提取目录
                        const swUrl = new URL(swPath, window.location.href)
                        scope = swUrl.pathname.substring(0, swUrl.pathname.lastIndexOf('/') + 1)
                    }
                    
                    console.log('[SW] Scope:', scope)
                    
                    this.swRegistration = await navigator.serviceWorker.register(swPath, {
                        scope: scope
                    })
                    
                    console.log('[SW] Service Worker registered successfully')
                    
                    // 等待 Service Worker 激活
                    await navigator.serviceWorker.ready
                    console.log('[SW] Service Worker ready')
                    
                    return this.swRegistration
                } catch (error) {
                    console.error('[SW] Service Worker registration failed:', error)
                    return null
                }
            },
            async clear() {
                if (!this.isSupported()) {
                    return
                }
                
                try {
                    // 尝试获取现有的 Service Worker 注册
                    const registration = this.swRegistration || await navigator.serviceWorker.getRegistration()
                    
                    if (!registration || !registration.active) {
                        console.log('[SW] No active Service Worker to clear cache')
                        return
                    }
                    
                    // 1. 先清除缓存
                    const messageChannel = new MessageChannel()
                    const promise = new Promise((resolve) => {
                        messageChannel.port1.onmessage = (event) => {
                            resolve(event.data)
                        }
                    })
                    
                    registration.active.postMessage(
                        { type: 'CLEAR_CACHE' },
                        [messageChannel.port2]
                    )
                    
                    const result = await promise
                    console.log('[SW] Cache cleared:', result)
                    
                    // 2. 注销 Service Worker，防止继续缓存
                    await registration.unregister()
                    console.log('[SW] Service Worker unregistered')
                    
                    // 3. 清除本地引用
                    this.swRegistration = null
                } catch (error) {
                    console.error('[SW] Failed to clear cache:', error)
                }
            },
            async getCacheSize() {
                if (!this.isSupported()) {
                    return { size: 0, files: 0 }
                }
                
                try {
                    // 尝试获取现有的 Service Worker 注册
                    const registration = this.swRegistration || await navigator.serviceWorker.getRegistration()
                    
                    if (!registration || !registration.active) {
                        return { size: 0, files: 0 }
                    }
                    
                    const messageChannel = new MessageChannel()
                    const promise = new Promise((resolve) => {
                        messageChannel.port1.onmessage = (event) => {
                            resolve(event.data)
                        }
                    })
                    
                    registration.active.postMessage(
                        { type: 'GET_CACHE_SIZE' },
                        [messageChannel.port2]
                    )
                    
                    return await promise
                } catch (error) {
                    console.error('[SW] Failed to get cache size:', error)
                    return { size: 0, files: 0 }
                }
            }
        }
        constructor(container, props) {
            Element.prototype.Map = this
            Element.prototype.NativeAPI = null
            Element.prototype.bDestroy = false
            if (defined(props)) {
                this.initCallback = defaultValue(props.initCallback, null)
                let systemThreadNum = 4
                if (navigator) {
                    systemThreadNum = navigator.hardwareConcurrency - 5
                    if (systemThreadNum < 4) {
                        systemThreadNum = 4
                    } else if (systemThreadNum > 8) {
                        systemThreadNum = 8
                    }
                }
                this.dataThreadNum = defaultValue(props.dataThreadNum, systemThreadNum)
                this.nodeNum = defaultValue(props.nodeNum, 3000)
            }
            this.basePath = defaultValue(props.basePath, "")
            if (this.basePath != "" && !this.basePath.endsWith('/')) {
                this.basePath += '/'
            }
            this.bCache = defaultValue(props.bCache, true)
            this.bProgress = defaultValue(props.bProgress, true)
            
            // 判断使用哪种缓存策略
            this.isHttps = window.location.protocol === "https:"
            this.useServiceWorker = this.isHttps && this.bCache && this.ServiceWorkerCache.isSupported()
            
            console.log(`[Cache Strategy] Protocol: ${window.location.protocol}`)
            console.log(`[Cache Strategy] Using: ${this.useServiceWorker ? 'Service Worker' : 'IndexedDB'}`)
            
            this.licIp = defaultValue(props.licIp, "")
            this.licPort = defaultValue(props.licPort, -1)
            this.protocol = 0
            if (this.isHttps) {
                this.protocol = 1
            }
            this.company = defaultValue(props.company, "浙江科澜信息技术有限公司")
            this.bShowCopyright = defaultValue(props.bShowCopyright, true)
            this.copyrightYear = defaultValue(props.copyrightYear, 2004)
            this.canvas = document.getElementById(container)
            this.mousePostionCallback = defaultValue(props.mousePostionCallback, null)
            this.mouseScaleCallback = defaultValue(props.mouseScaleCallback, null)
            const rect = this.canvas.getBoundingClientRect()
            this.canvas.width = rect.width
            this.canvas.height = rect.height
            this.parentNode = this.canvas.parentNode
            if (this.bProgress) {
                this.initProgress(rect)
            }
            console.log("canvas size:" + this.canvas.getBoundingClientRect().width + "," + this.canvas.getBoundingClientRect().height)

            this.bInit = false
            Element.prototype.stepFlag = false
            Element.prototype.step = () => {
                if (Element.prototype.stepFlag) {
                    Module._step()
                    window.requestAnimationFrame(Element.prototype.step)
                }
            }
            Element.prototype.stepStart = () => {
                if (!Element.prototype.stepFlag) {
                    Element.prototype.stepFlag = true
                    if (!this.bInit && defined(this.initCallback)) {
                        if (this.bProgress) {
                            this.bLoading = false
                            this.fadeOutProgress()
                        }
                        const endTime = performance.now()
                        const cost = endTime - startTime
                        console.log(`CooWasm模块初始化总耗时: ${cost} 毫秒`)
                        console.log("Version:" + this.version + " TimeStamp:" + BUILD_TIMESTAMP)
                        // alert(cost)
                        this.getObjects()
                        this.initCallback()
                        this.bInit = true
                    }
                    window.requestAnimationFrame(Element.prototype.step)
                }
            }
            Element.prototype.stepEnd = () => {
                Element.prototype.stepFlag = false
            }
            
            // 初始化加载流程
            if (this.bCache) {
                // HTTPS：使用 Service Worker
                if (this.useServiceWorker) {
                    this.initWithServiceWorker(container)
                } 
                // HTTP：使用 IndexedDB
                else {
                    this.initWithIndexedDB(container)
                }
            } else {
                // 不使用缓存
                this.initWithoutCache(container)
            }
            
            // 初始化键盘快捷键监听器
            this.initKeyboardShortcuts()
        }
        
        /**
         * 使用 Service Worker 初始化（HTTPS）
         * @private
         */
        async initWithServiceWorker(container) {
            console.log('[Init] Using Service Worker cache strategy')
            
            // 注册 Service Worker
            await this.ServiceWorkerCache.register(this.basePath)
            
            const dataTimeStart = performance.now()
            
            // 预加载 .data 文件（Service Worker 会缓存）
            const dataResponse = await fetch(this.basePath + 'cooWasm.data')
            const dataArrayBuffer = await dataResponse.arrayBuffer()
            console.log(`[SW Init] cooWasm.data preloaded: ${(dataArrayBuffer.byteLength / 1024 / 1024).toFixed(2)} MB`)
            
            // Service Worker 会自动拦截并缓存请求
            window.Module = {
                canvas: this.canvas,
                instantiateWasm: (imports, successCallback) => {
                    const instantiate = async () => {
                        try {
                            let time1 = performance.now()
                            const wasmUrl = this.basePath + 'cooWasm.wasm'
                            
                            console.log('[SW Init] Loading WASM from:', wasmUrl)
                            
                            // 使用流式编译（Service Worker 会处理缓存）
                            if (typeof WebAssembly.instantiateStreaming === 'function') {
                                try {
                                    const { instance, module } = await WebAssembly.instantiateStreaming(
                                        fetch(wasmUrl),
                                        imports
                                    )
                                    let time2 = performance.now()
                                    console.log(`[SW Init] instantiateStreaming 耗时: ${time2 - time1} 毫秒`)
                                    
                                    this.wasmInstance = instance
                                    successCallback(instance, module)
                                    return instance.exports
                                } catch (streamErr) {
                                    console.warn('[SW Init] Streaming failed, fallback:', streamErr)
                                }
                            }
                            
                            // 回退方案
                            const response = await fetch(wasmUrl)
                            const wasmBytes = await response.arrayBuffer()
                            const { instance, module } = await WebAssembly.instantiate(wasmBytes, imports)
                            let time2 = performance.now()
                            console.log(`[SW Init] Traditional load 耗时: ${time2 - time1} 毫秒`)
                            
                            this.wasmInstance = instance
                            successCallback(instance, module)
                            return instance.exports
                        } catch (err) {
                            console.error('[SW Init] Failed to instantiate:', err)
                            throw err
                        }
                    }
                    instantiate()
                    return {}
                },
                getPreloadedPackage: (remotePackageName, remotePackageSize) => {
                    // 直接返回预加载的 ArrayBuffer（同步）
                    console.log('[SW Init] Returning preloaded data')
                    return dataArrayBuffer
                },
                onRuntimeInitialized: () => {
                    console.log("[SW Init] CooWasm initialized")
                    const dataTimeEnd = performance.now()
                    console.log(`[SW Init] Total time: ${dataTimeEnd - dataTimeStart} 毫秒`)
                    this.initApp(container, this.dataThreadNum, this.nodeNum, this.licIp, this.licPort, this.protocol, this.company, this.bShowCopyright, this.copyrightYear)
                }
            }
            
            // 加载主 JS 文件
            const script = document.createElement('script')
            script.src = this.basePath + 'cooWasm.js'
            script.onload = () => {
                console.log("[SW Init] cooWasm.js loaded")
            }
            document.body.appendChild(script)
        }
        
        /**
         * 使用 IndexedDB 初始化（HTTP）
         * @private
         */
        initWithIndexedDB(container) {
            console.log('[Init] Using IndexedDB cache strategy')
            
            if (this.bCache) {
                const download = async (packageName, packageSize) => {
                    try {
                        const cachedFile = await this.IndexedDBCache.get(packageName, this.version)
                        if (cachedFile) {
                            console.log(`Using cached ${packageName}`)
                            let result = await cachedFile
                            return result
                        }
                    } catch (error) {
                        console.warn(`Failed to retrieve ${packageName} from cache:`, error)
                    }

                    console.log(`Loading ${packageName} from network`)
                    try {
                        const response = await fetch(this.basePath + packageName)
                        const arrayBuffer = await response.arrayBuffer()
                        // 将文件写入缓存
                        try {
                            await this.IndexedDBCache.set(packageName, arrayBuffer, this.version)
                            console.log(`Cached ${packageName}`)
                        } catch (error) {
                            console.warn(`Failed to cache ${packageName}:`, error)
                        }

                        let result = await arrayBuffer
                        return result
                    } catch (error) {
                        console.error(`Failed to load ${packageName} from network:`, error)
                        throw error
                    }
                }
                const dataTimeStart = performance.now()
                download("cooWasm.data", 0).then(data => {
                    const dataTimeEnd = performance.now()
                    let cost = dataTimeEnd - dataTimeStart
                    console.log(`cooWasm.data耗时: ${cost} 毫秒`)
                    window.Module = {
                        canvas: this.canvas,
                        instantiateWasm: (imports, successCallback) => {
                            const instantiate = async () => {
                                try {
                                    // 尝试从 IndexedDB 缓存中获取编译后的模块
                                    let time1 = performance.now()
                                    const cachedModule = await this.IndexedDBCache.get('cooWasm.wasm', this.version)
                                    if (cachedModule) {
                                        let time2 = performance.now()
                                        let cost = time2 - time1
                                        console.log(`IndexedDBCache.get cooWasm.wasm 耗时: ${cost} 毫秒`)
                                        console.log('Using cached WebAssembly module')
                                        let { instance, module } = await WebAssembly.instantiate(cachedModule, imports)
                                        let time3 = performance.now()
                                        cost = time3 - time2
                                        console.log(`WebAssembly.instantiate cooWasm.wasm 耗时: ${cost} 毫秒`)
                                        this.wasmInstance = instance
                                        successCallback(instance, module)
                                        return instance.exports
                                    }
                                } catch (err) {
                                    console.warn('Failed to load cached module:', err)
                                }

                                // 如果缓存中没有，则从网络加载并流式编译
                                try {
                                    let time1 = performance.now()
                                    const wasmUrl = this.basePath + 'cooWasm.wasm'
                                    
                                    // 优先使用 instantiateStreaming（流式编译）
                                    if (typeof WebAssembly.instantiateStreaming === 'function') {
                                        try {
                                            console.log('Using WebAssembly.instantiateStreaming for faster compilation')
                                            
                                            // 创建 fetch promise，这样可以复用响应
                                            const responsePromise = fetch(wasmUrl)
                                            
                                            // 流式编译和实例化
                                            const { instance, module } = await WebAssembly.instantiateStreaming(
                                                responsePromise.then(r => r.clone()),
                                                imports
                                            )
                                            let time2 = performance.now()
                                            let cost = time2 - time1
                                            console.log(`WebAssembly.instantiateStreaming 耗时: ${cost} 毫秒`)

                                            this.wasmInstance = instance
                                            successCallback(instance, module)

                                            // 后台缓存原始字节码（不阻塞主流程）
                                            responsePromise.then(async (response) => {
                                                try {
                                                    const wasmBytes = await response.arrayBuffer()
                                                    await this.IndexedDBCache.set('cooWasm.wasm', wasmBytes, this.version)
                                                    console.log('WebAssembly module cached in background')
                                                } catch (err) {
                                                    console.warn('Failed to cache module:', err)
                                                }
                                            })

                                            return instance.exports
                                        } catch (streamErr) {
                                            console.warn('instantiateStreaming failed, fallback to traditional method:', streamErr)
                                        }
                                    }
                                    
                                    // 回退方案：传统方式（fetch + arrayBuffer + instantiate）
                                    console.log('Using traditional fetch + instantiate method')
                                    let time1Fallback = performance.now()
                                    const response = await fetch(wasmUrl)
                                    let time2 = performance.now()
                                    let cost = time2 - time1Fallback
                                    console.log(`fetch cooWasm.wasm 耗时: ${cost} 毫秒`)
                                    
                                    const wasmBytes = await response.arrayBuffer()
                                    let time3 = performance.now()
                                    cost = time3 - time2
                                    console.log(`response.arrayBuffer 耗时: ${cost} 毫秒`)
                                    
                                    const { instance, module } = await WebAssembly.instantiate(wasmBytes, imports)
                                    let time4 = performance.now()
                                    cost = time4 - time3
                                    console.log(`WebAssembly.instantiate 耗时: ${cost} 毫秒`)

                                    // 将字节码缓存到 IndexedDB
                                    try {
                                        await this.IndexedDBCache.set('cooWasm.wasm', wasmBytes, this.version)
                                        let time5 = performance.now()
                                        cost = time5 - time4
                                        console.log(`IndexedDBCache.set 耗时: ${cost} 毫秒`)
                                        console.log('WebAssembly module cached')
                                    } catch (err) {
                                        console.warn('Failed to cache module:', err)
                                    }

                                    this.wasmInstance = instance
                                    successCallback(instance, module)
                                    return instance.exports
                                } catch (err) {
                                    console.error('Failed to instantiate WebAssembly module:', err)
                                    throw err
                                }
                            }
                            instantiate()
                            return {} // 这里返回一个空对象，因为实际的 exports 会通过 successCallback 提供
                        },
                        getPreloadedPackage: (remotePackageName, remotePackageSize) => {
                            //console.log('Preloaded cooWasm.data file')
                            return data

                        },
                        onRuntimeInitialized: () => {
                            console.log("CooWasm init....")
                            this.initApp(container, this.dataThreadNum, this.nodeNum, this.licIp, this.licPort, this.protocol, this.company, this.bShowCopyright, this.copyrightYear)
                            const initializedTime = performance.now()
                            let cost = initializedTime - dataTimeEnd
                            console.log(`onRuntimeInitialized耗时: ${cost} 毫秒`)
                        }
                    }
                    // 然后加载 Emscripten 生成的 JavaScript 文件
                    const script = document.createElement('script')
                    script.src = this.basePath + 'cooWasm.js'
                    script.onload = () => {
                        console.log("cooWasm.js loaded")
                    }
                    document.body.appendChild(script)
                })
            }
        }
        
        /**
         * 不使用缓存初始化
         * @private
         */
        async initWithoutCache(container) {
            console.log('[Init] No cache strategy (streaming compilation enabled)')
            
            // 调用清除缓存函数
            await this.clearCache()
            
            const dataTimeStart = performance.now()
            
            // 预加载 .data 文件
            const dataResponse = await fetch(this.basePath + 'cooWasm.data')
            const dataArrayBuffer = await dataResponse.arrayBuffer()
            console.log(`[No Cache] cooWasm.data loaded: ${(dataArrayBuffer.byteLength / 1024 / 1024).toFixed(2)} MB`)
            
            // 使用流式编译，但不缓存
            window.Module = {
                canvas: this.canvas,
                instantiateWasm: (imports, successCallback) => {
                    const instantiate = async () => {
                        try {
                            let time1 = performance.now()
                            const wasmUrl = this.basePath + 'cooWasm.wasm'
                            
                            console.log('[No Cache] Loading WASM from:', wasmUrl)
                            
                            // 使用流式编译（不缓存）
                            if (typeof WebAssembly.instantiateStreaming === 'function') {
                                try {
                                    const { instance, module } = await WebAssembly.instantiateStreaming(
                                        fetch(wasmUrl),
                                        imports
                                    )
                                    let time2 = performance.now()
                                    console.log(`[No Cache] instantiateStreaming 耗时: ${time2 - time1} 毫秒`)
                                    
                                    this.wasmInstance = instance
                                    successCallback(instance, module)
                                    return instance.exports
                                } catch (streamErr) {
                                    console.warn('[No Cache] Streaming failed, fallback:', streamErr)
                                }
                            }
                            
                            // 回退方案
                            const response = await fetch(wasmUrl)
                            const wasmBytes = await response.arrayBuffer()
                            const { instance, module } = await WebAssembly.instantiate(wasmBytes, imports)
                            let time2 = performance.now()
                            console.log(`[No Cache] Traditional load 耗时: ${time2 - time1} 毫秒`)
                            
                            this.wasmInstance = instance
                            successCallback(instance, module)
                            return instance.exports
                        } catch (err) {
                            console.error('[No Cache] Failed to instantiate:', err)
                            throw err
                        }
                    }
                    instantiate()
                    return {}
                },
                getPreloadedPackage: (remotePackageName, remotePackageSize) => {
                    console.log('[No Cache] Returning preloaded data')
                    return dataArrayBuffer
                },
                onRuntimeInitialized: () => {
                    console.log("CooWasm init....")
                    const dataTimeEnd = performance.now()
                    console.log(`[No Cache] Total time: ${dataTimeEnd - dataTimeStart} 毫秒`)
                    this.initApp(container, this.dataThreadNum, this.nodeNum, this.licIp, this.licPort, this.protocol, this.company, this.bShowCopyright, this.copyrightYear)
                }
            }
            
            // 加载主 JS 文件
            const script = document.createElement('script')
            script.src = this.basePath + 'cooWasm.js'
            script.onload = () => {
                console.log("[No Cache] cooWasm.js loaded")
            }
            document.body.appendChild(script)
        }
        
        /**
         * 渐变移除加载动画
         * @param {Function} callback 渐变完成后的回调函数
         */
        fadeOutProgress(callback) {
            if (!this.progressDiv) {
                if (callback) callback()
                return
            }

            try {
                // 1. 获取当前canvas内容
                const canvasImage = this.canvas.toDataURL('image/png')

                // 2. 创建一个背景图层，使用canvas内容
                const bgDiv = document.createElement('div')
                bgDiv.style.position = 'absolute'
                bgDiv.style.top = '0'
                bgDiv.style.left = '0'
                bgDiv.style.width = '100%'
                bgDiv.style.height = '100%'
                bgDiv.style.backgroundImage = `url(${canvasImage})`
                bgDiv.style.backgroundSize = 'cover'
                bgDiv.style.backgroundPosition = 'center'
                bgDiv.style.zIndex = '999' // 低于loading层
                bgDiv.style.opacity = '0'

                // 3. 添加到progressDiv之前
                this.parentNode.insertBefore(bgDiv, this.progressDiv)

                // 4. 设置过渡效果
                bgDiv.style.transition = 'opacity 1s ease-in'
                this.progressDiv.style.transition = 'opacity 1s ease-out'
                this.progressDiv.style.opacity = '1'

                // 5. 执行过渡动画
                requestAnimationFrame(() => {
                    bgDiv.style.opacity = '1'
                    this.progressDiv.style.opacity = '0'

                    // 监听过渡结束事件
                    this.progressDiv.addEventListener('transitionend', () => {
                        // 6. 清理元素
                        if (this.progressDiv && this.progressDiv.parentNode) {
                            this.parentNode.removeChild(this.progressDiv)
                        }

                        if (this.progressStyle && this.progressStyle.parentNode) {
                            document.head.removeChild(this.progressStyle)
                        }

                        // 7. 淡出背景图并显示实际canvas
                        setTimeout(() => {
                            bgDiv.style.opacity = '0'
                            bgDiv.addEventListener('transitionend', () => {
                                // 移除背景图层
                                if (bgDiv && bgDiv.parentNode) {
                                    this.parentNode.removeChild(bgDiv)
                                }

                                this.progressDiv = null
                                this.progressStyle = null

                                // 执行回调
                                if (callback) callback()
                            }, { once: true })
                        }, 100)
                    }, { once: true })
                })
            } catch (error) {
                // 如果截图过程出错，回退到简单淡出效果
                console.warn('Canvas transition effect failed, using simple fade out instead:', error)

                this.progressDiv.style.transition = 'opacity 1s ease-out'
                this.progressDiv.style.opacity = '0'

                this.progressDiv.addEventListener('transitionend', () => {
                    if (this.progressDiv && this.progressDiv.parentNode) {
                        this.parentNode.removeChild(this.progressDiv)
                    }

                    if (this.progressStyle && this.progressStyle.parentNode) {
                        document.head.removeChild(this.progressStyle)
                    }

                    this.progressDiv = null
                    this.progressStyle = null

                    if (callback) callback()
                }, { once: true })
            }
        }
        handleMouseUp = (e) => {
            if (e.button === 2) {
                const now = Date.now()
                if (now - this.lastRightClick < this.DOUBLE_CLICK_TIME) {
                    //console.log("right double click")
                    this.bRoate = true
                    this.lastRightClick = 0
                } else {
                    this.bRoate = false
                    this.lastRightClick = now
                }
            } else {
                this.bRoate = false
            }
        }
        handleMouseLeave = (e) => {
            if (!this.bRoate) {
                const mouseUpEvent = new MouseEvent('mouseup', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                    button: 0,
                    buttons: 1
                })
                //console.log("dispatchEvent")
                this.canvas.dispatchEvent(mouseUpEvent)
            }
        }

        initApp(container, threadNum, nodeNum, licIp, licPort, protocol, companyName, isShowCp, cpYear) {
            console.log("Application init....")
            this.canvas = document.getElementById(container)
            const rect = this.canvas.getBoundingClientRect()
            this.canvas.width = rect.width
            this.canvas.height = rect.height
            Module.canvas = this.canvas
            Module._init(this.canvas.width, this.canvas.height, threadNum, nodeNum, encode(licIp), licPort, protocol, encode(companyName), isShowCp, cpYear)
            // 禁止右键菜单
            this.canvas.addEventListener('contextmenu', (e) => {
                e.preventDefault()
            })
            this.canvas.addEventListener('mouseup', this.handleMouseUp)
            this.canvas.addEventListener('mouseleave', this.handleMouseLeave)
            Element.prototype.ResizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    //设置窗口
                    // const width = entry.contentRect.width
                    // const height = entry.contentRect.height
                    // GLFW.active.width = width
                    // GLFW.active.height = height
                    // GLFW.active.framebufferWidth = width
                    // GLFW.active.framebufferHeight = height
                    //设置画布
                    let nowRect = this.canvas.getBoundingClientRect()
                    this.canvas.width = nowRect.width
                    this.canvas.height = nowRect.height
                    Browser.updateResizeListeners()
                    //GLFW.onWindowSizeChanged()
                }
            })
            Element.prototype.ResizeObserver.observe(this.canvas)
            Element.prototype.Wasm = Module
            Element.prototype.NativeAPI = bind(Module)
            Element.prototype.DestroyState = false
            //Element.prototype.ActiveHandle = Module.ctx.canvas.GLctxObject.handle
            //Element.prototype.ActiveWin = GLFW.active
        }
        /**
         * 初始化键盘快捷键监听器
         * @private
         */
        initKeyboardShortcuts() {
            this.keyboardHandler = (event) => {
                // 检查 Ctrl + Alt + K 组合键
                if (event.ctrlKey && event.altKey && event.key.toLowerCase() === 'k') {
                    event.preventDefault()
                    this.toggleMonitor()
                }
            }
            
            // 添加全局键盘事件监听器
            document.addEventListener('keydown', this.keyboardHandler)
            console.log('Map: 键盘快捷键已初始化 (Ctrl + Alt + K 切换监控器)')
        }
        /**
         * 切换监控器显示状态
         * @private
         */
        toggleMonitor() {
            try {
                if (this.monitor) {
                    // 如果监控器已存在，销毁它
                    this.monitor.destroy()
                    this.monitor = null
                    console.log('Map: 监控器已关闭')
                } else {
                    // 创建新的监控器实例
                    this.monitor = new Monitor({mapInstance:this})
                    console.log('Map: 监控器已开启')
                }
            } catch (error) {
                console.error('Map: 切换监控器时发生错误:', error)
            }
        }
        /**
         * 启用或禁用键盘快捷键
         * @param {Boolean} enabled 是否启用快捷键
         */
        enableKeyboardShortcuts(enabled) {
            if (enabled) {
                if (!this.keyboardHandler) {
                    this.initKeyboardShortcuts()
                }
            } else {
                if (this.keyboardHandler) {
                    document.removeEventListener('keydown', this.keyboardHandler)
                    this.keyboardHandler = null
                    console.log('Map: 键盘快捷键已禁用')
                }
            }
        }
        initProgress(rect) {
            // 获取目标元素的位置和大小信息
            const top = rect.top + window.scrollY // 考虑页面滚动的距离
            const left = rect.left + window.scrollX // 考虑页面滚动的距离
            const width = rect.width
            const height = rect.height
            // 创建加载动画的容器div而不是canvas
            this.progressDiv = document.createElement('div')
            this.progressDiv.id = 'loadingContainer'
            this.progressDiv.style.position = 'absolute'
            this.progressDiv.style.top = `${top}px`
            this.progressDiv.style.left = `${left}px`
            this.progressDiv.style.width = `${width}px`
            this.progressDiv.style.height = `${height}px`
            this.progressDiv.style.backgroundColor = '#081E3F'
            this.progressDiv.style.zIndex = '1000'

            // 创建spinner元素
            const spinnerDiv = document.createElement('div')
            spinnerDiv.className = 'loader-spinna'

            // 添加样式到head
            const styleElement = document.createElement('style')
            styleElement.textContent = `
                .loader-spinna {
                    width: 92.2px;
                    height: 92.2px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: #081e3f;
                    position: fixed;
                    transform: scale(6);
                    top: calc(50% - 46.1px);
                    left: calc(50% - 46.1px);
                }
                .loader-spinna:before, .loader-spinna:after {
                    box-sizing: border-box;
                    content: "";
                    position: absolute;
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    border-radius: 50%;
                    z-index: 1;
                }
                .loader-spinna:before {
                    border: 3px dotted #081e3f;
                    box-shadow: inset 0 0 0 3em #081e3f;
                }
                .loader-spinna:after {
                    z-index: 0;
                    border-width: 10px;
                    border-style: solid;
                    -o-border-image: linear-gradient(to bottom, #19A6CF 0%, transparent 100%);
                    border-image: linear-gradient(to bottom, #19A6CF 0%, transparent 100%);
                    border-image-slice: 0 0 0 20;
                    -webkit-animation: spinnaRot 2s infinite linear;
                    animation: spinnaRot 2s infinite linear;
                }
                @-webkit-keyframes spinnaRot {
                    to {
                        transform: rotate(359deg);
                    }
                }
                @keyframes spinnaRot {
                    to {
                        transform: rotate(359deg);
                    }
                }
            `

            document.head.appendChild(styleElement)
            this.progressDiv.appendChild(spinnerDiv)
            this.parentNode.appendChild(this.progressDiv)

            // 保存引用以便后续移除
            this.progressStyle = styleElement
            this.bLoading = true
        }
        /**
         * 清除三维地图缓存（支持 IndexedDB 和 Service Worker）。
         * @async
         * @returns {Promise<void>} 这个方法不返回任何值
         * @example
         * map.clearCache()
         */
        async clearCache() {
            try {
                // 清除 IndexedDB 缓存
                await this.IndexedDBCache.clear()
                console.log('[Cache] IndexedDB cache cleared')
                // 如果使用了 Service Worker，也清除 SW 缓存
                await this.ServiceWorkerCache.clear()
                console.log('[Cache] Service Worker cache cleared')
                console.log('[Cache] All caches cleared successfully')
            } catch (error) {
                console.error('[Cache] Failed to clear cache:', error)
            }
        }
        /**
         * 开启或者关闭三维地图漫游。
         * @param {Boolean} state 开关状态。
         * @example
         * // 禁用漫游
         * map.enableRoam(false)
         */
        enableRoam(state) {
            Element.prototype.NativeAPI.EnableRoam(state)
        }

        /**
         * 开启或者关闭鼠标位置回调。
         * @param {Boolean} state 开关状态。
         * @param {CallbackObj} func 返回经纬度位置信息的回调函数。
         * @example
         * map.enableMousePosition(true, position=>{
         *      console.log(position)
         * })
         */
        enableMousePosition(state, callback) {
            if (!state) {
                if (this.mousePostionCallback) {
                    callbackSystem.remove("", "CursorLocation")
                    this.mousePostionCallback = null
                }
            } else {
                if (defined(callback)) {
                    if (this.mousePostionCallback == null) {
                        this.mousePostionCallback = callback
                        callbackSystem.register("", "CursorLocation", (position) => {
                            let vec3 = Vec3Obj.fromStrEx(position)
                            this.mousePostionCallback(vec3)
                        })
                    }
                } else {
                    console.log("need bind a function!")
                }
            }
        }
        /**
         * 开启或者关闭鼠标位置对应比例尺回调。
         * @param {Boolean} state 开关状态。
         * @param {CallbackString} func 返回鼠标位置对应比例尺信息的回调函数,字符串格式: 像素值/米。
         * @example
         * map.enableMouseScale(true, str=>{
         *      console.log(str)
         * })
         */
        enableMouseScale(state, callback) {
            if (!state) {
                if (this.mouseScaleCallback) {
                    callbackSystem.remove("", "CursorScale")
                    this.mouseScaleCallback = null
                }
            } else {
                if (defined(callback)) {
                    if (this.mouseScaleCallback == null) {
                        this.mouseScaleCallback = callback
                        callbackSystem.register("", "CursorScale", (scale) => {
                            this.mouseScaleCallback(scale)
                        })
                    }
                } else {
                    console.log("need bind a function!")
                }
            }
        }
        /**
         * 显隐三维地图本身。
         * @param {Boolean} state 显隐状态。
         * @example
         * // 显隐三维地图
         * map.visible(false)
         */
        visible(state) {
            if (defined(this.canvas)) {
                if (state) {
                    this.canvas.style.display = "block"
                    Element.prototype.stepStart()
                } else {
                    this.canvas.style.display = "none"
                    Element.prototype.stepEnd()
                }
            }
        }
        /**
         * 设置相机LodScale
         * @param {Number} lodScale 调度比例值。
         * @example
         * // 设置相机LodScale
         * map.setLodScale(1.0)
         */
        setLodScale(lodScale) {
            Element.prototype.NativeAPI.SetLodScale(lodScale)
        }
        /**
         * 从场景中销毁自身。
         * @returns null 空值。
         * @example
         * // 销毁对象
         * xxx = xxx.destroy()
         */
        destroy() {
            const startT = performance.now()
            
            // 清理监控器
            if (this.monitor) {
                this.monitor.destroy()
                this.monitor = null
            }
            
            // 清理键盘事件监听器
            if (this.keyboardHandler) {
                document.removeEventListener('keydown', this.keyboardHandler)
                this.keyboardHandler = null
            }
            
            if (Element.prototype.ResizeObserver) {
                Element.prototype.ResizeObserver.disconnect()
                Element.prototype.ResizeObserver = null
            }
            Element.prototype.NativeAPI.quit()
            this.bInit = false
            Element.prototype.PickerInstance = null
            Element.prototype.DestroyState = true
            groupClear()
            callbackSystem.clear()
            const endT = performance.now()
            const delT = (endT - startT) * 0.001
            console.log(`Map destroy. cost time: ${delT} s`)
            return null
        }
        /**
         * 测试内存极限。
         * @param {Number} step 步长。
         * @param {Number} times 测试次数。
         * @example
         * // 测试内存极限
         * map.memoryTest()
         */
        memoryTest(step, times) {
            let val = defaultValue(step, 1)
            let val1 = defaultValue(times, -1)
            Element.prototype.NativeAPI.MemoryTest(val, times)
        }
        /**
         * 获取内存使用情况。
         * @returns {Number} 已使用内存（MB）。
         */
        memoryUsage() {
            let used = Element.prototype.NativeAPI.MemoryInfo()
            return used
        }
        /**
         * 获取当前请求节点数。
         * @returns {Number} 当前请求节点个数。
         */
        getDataRequest(){
            let num = Element.prototype.NativeAPI.GetDataRequest()
            return num
        }
        /**
         * 获取当前调度节点总数。
         * @returns {Number} 当前调度节点总数。
         */
        getNodes() {
            let num = Element.prototype.NativeAPI.GetNodes()
            return num
        }
        /**
         * 获取当前激活调度节点数。
         * @returns {Number} 当前激活调度节点数。
         */
        getActiveNodes() {
            let num = Element.prototype.NativeAPI.GetActiveNodes()
            return num
        }
        /**
         * 获取已加载在地图中的对象，通过各类对象数组返回。
         * @param {Boolean} [bGetProps=true] 是否获取属性。
         * @example
         * // 获取对象
         * map.getObjects()
         */
        getObjects = (bGetProps) => {
            bGetProps = defaultValue(bGetProps, false)
            //清理分组信息
            groupClear()
            let pAvatarInfos = Element.prototype.NativeAPI.MapImpl_getAllAvatars()
            let size = Element.prototype.NativeAPI.AvatarInformationList_GetAvatarInformationsSize(pAvatarInfos)
            for (let z = 0; z < size; ++z) {
                let pAvatarInfo = Element.prototype.NativeAPI.AvatarInformationList_GetAvatarInformation(pAvatarInfos, z)
                // let avatarName = Element.prototype.NativeAPI.AvatarInformation_GetName(pAvatarInfo)
                // console.log("avatar name:" + (avatarName))
                let pAvatarUuid = Element.prototype.NativeAPI.AvatarInformation_GetUuid(pAvatarInfo)
                let avatarUuid = Element.prototype.NativeAPI.Uuid_GetId(pAvatarUuid)
                console.log("avatar uuid:" + (avatarUuid))
                let pAvatarType = Element.prototype.NativeAPI.AvatarInformation_GetObjectType(pAvatarInfo)
                let cateName = Element.prototype.NativeAPI.ObjectType_GetCategory(pAvatarType)
                let typeName = Element.prototype.NativeAPI.ObjectType_GetName(pAvatarType)
                let avatarCN = cateName + "." + typeName
                console.log("avatar category:" + avatarCN)
                let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
                if (bGetProps) {
                    let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
                    for (let i = 0; i < avatarPropSize; ++i) {
                        let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        let isW = Element.prototype.NativeAPI.Property_GetIsWritable(pProp)
                        console.log("avatar property:" + pProp + "|" + name + "|" + value + "|" + isW)
                    }
                }
                let avatarAcSize = Element.prototype.NativeAPI.Avatar_GetAvatarComponentsSize(pAvatar)
                if (avatarAcSize == 0) {
                    group(avatarCN, null, avatarUuid, null)
                } else {
                    for (let j = 0; j < avatarAcSize; ++j) {
                        let pAc = Element.prototype.NativeAPI.Avatar_GetAvatarComponent(pAvatar, j)
                        let pUuid = Element.prototype.NativeAPI.AvatarComponent_GetUuid(pAc)
                        let componentUuid = Element.prototype.NativeAPI.Uuid_GetId(pUuid)
                        // console.log("avtarComponent uuid:" + UTF8ToString(uuid))
                        console.log("avtarComponent uuid:" + (componentUuid))
                        let pType = Element.prototype.NativeAPI.AvatarComponent_GetObjectType(pAc)
                        let cate = Element.prototype.NativeAPI.ObjectType_GetCategory(pType)
                        let name = Element.prototype.NativeAPI.ObjectType_GetName(pType)
                        let componentCN = cate + "." + name
                        console.log("avtarComponent category:" + componentCN)
                        //分类
                        group(avatarCN, componentCN, avatarUuid, componentUuid)

                        if (bGetProps) {
                            let propSize = Element.prototype.NativeAPI.AvatarComponent_GetPropertiesSize(pAc)
                            for (let z = 0; z < propSize; ++z) {
                                let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                                let isW = Element.prototype.NativeAPI.Property_GetIsWritable(pProp)
                                // console.log("avtarComponent property:" + pProp + "|" + name + "|" + value + "|" + isW)
                                // console.log("avtarComponent property:" + UTF8ToString(name) + "  " + UTF8ToString(value) + "  " + isW)
                                //Module._free(name)
                                // Module._free(value)
                            }
                        }
                    }
                }
            }
            return null
        }
    }
    return Map
})

